import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedSettings } from '../models/shared-settings';
import { ActivityBlockingService } from '../services/activity-blocking.service';
import { Product, ProductSubinventorySummary } from '../models/product';
import {Observable, map} from 'rxjs';
import { url } from '../helpers/url';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root'
})
export class ProductListService {
    constructor(
            private http: HttpClient,
            private settings: SharedSettings,
            private activityService: ActivityBlockingService) {
    }

    private updateFields(product: Product): void {
        if (!product.maxLoadQuantity)
            product.maxLoadQuantity = 1000000;

        product.label = `${product.itemNumber} - ${product.itemDescription}`;
    }

    public getProducts(siteId: string): Observable<ProductSubinventorySummary> {
        const handle = this.activityService.StartWorking('ProductListService');
        return this.http.get<ProductSubinventorySummary>(this.settings.apiBaseUrl + url`sites/${siteId}/products`)
            .pipe(map(currentProducts => {
                this.activityService.FinishWorking(handle);
                currentProducts.products.forEach(p => { this.updateFields(p); });
                currentProducts.products.sort((l, r) => l.label.localeCompare(r.label));
                return currentProducts;
            }));
    }

    public getAllProducts(): Observable<Product[]> {
        return this.http.get<Product[]>(this.settings.apiBaseUrl + url`products`)
            .pipe(map(products => {
                products.forEach(p => { this.updateFields(p); });
                products.sort((l, r) => l.label.localeCompare(r.label));
                return products;
            }));
    }

    public getProductsByCustomer(
            siteId: string,
            subinventoryId: number,
            customerId: number,
            poolerId: number,
            loadedDate: DateTime,
            loadType: string): Observable<number[]> {
        return this.http.get<number[]>(this.settings.apiBaseUrl + url`customer/products?siteId=${
            siteId
        }&subinventoryId=${
            subinventoryId
        }&customerId=${
            customerId
        }&poolerId=${
            poolerId
        }&loadedDate=${
            loadedDate.toISODate()
        }&loadType=${
            loadType
        }`);
    }
}
